import one from "./01";
import two from "./02";
import three from "./03";
import four from "./04";
import five from "./05";
import six from "./06";
import seven from "./07";
import eight from "./08";
const dataConfig = {
    1000: one,
    1001: two,
    1002: three,
    1003: four,
    1004: five,
    1005: six,
    1006: seven,
    1007: eight
};
const courseId = window.plateId;
export default dataConfig[courseId];
